<template>
  <v-sheet>
    <v-expansion-panels flat>
      <v-expansion-panel v-model="filtersPanel">
        <v-expansion-panel-header class="d-inline-flex align-center no-flexing">
          <v-icon left class="mr-2">mdi-filter-variant</v-icon>
          <span class="font-weight-bold mr-2">
            {{ translations.filtersTitle[lang] || 'Filters' }}:
          </span>
          <v-col cols="12" md="11" class="d-flex flex-wrap align-center">
            <v-chip
              v-for="(value, key) in activeFilters"
              :key="key"
              class="ma-1"
              close
              @click:close="removeFilter(key)"
            >
              {{ translations[key] ? translations[key][lang] : key }}:
              <template
                v-if="
                  ['child_id', 'first_transaction_store_id', 'registration_store_id'].includes(key)
                "
              >
                {{
                  storesData[
                    key === 'child_id'
                      ? 'child'
                      : key === 'first_transaction_store_id'
                        ? 'firstTransaction'
                        : 'registration'
                  ].stores.find((store) => store.store_id === value)?.app_name || value
                }}
              </template>
              <template v-else-if="key === 'country_id'">
                {{ countries.find((c) => c.country_id === value)?.name || value }}
              </template>
              <template v-else-if="key === 'county_id'">
                {{ counties.find((c) => c.county_id === value)?.name || value }}
              </template>
              <template v-else-if="key === 'store_point_title_ids'">
                <template v-if="tiers && tiers.length">
                  {{
                    value
                      .map((id) => tiers.find((t) => String(t.store_point_title_id) === String(id)))
                      .map((t) => (t.title && t.title[lang]) || t.store_point_title_id)
                      .join(', ')
                  }}
                </template>
                <template v-else>
                  {{ value }}
                </template>
              </template>
              <template v-else-if="['marketing', 'sms', 'viber', 'push', 'mail'].includes(key)">
                {{ value === true ? translations.yes[lang] : translations.no[lang] }}
              </template>
              <template v-else-if="translations[value]">
                {{ translations[value][lang] }}
              </template>
              <template v-else>
                {{ value }}
              </template>
            </v-chip>
            <v-btn
              text
              color="error"
              depressed
              class="text-capitalize"
              v-if="Object.keys(activeFilters).length"
              @click.stop="clearAllFilters"
            >
              {{ translations.clearAll[lang] }}
            </v-btn>
          </v-col>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row align="stretch" class="justify-space-between">
            <v-col cols="12" md="" class="d-flex flex-column" style="flex-grow: 2">
              <v-row class="mt-0 pb-1">
                <!-- <v-col cols="12" sm="12">
                                    <v-autocomplete
                                        :items="storesData.child.stores"
                                        item-text="app_name"
                                        item-value="store_id"
                                        v-model="filters.child_id"
                                        :label="translations.child_id[lang]"
                                        outlined
                                        dense
                                        clearable
                                        :error-messages="error.child_id"
                                        @change="
                                            updateFilter(
                                                'child_id',
                                                filters.child_id
                                            )
                                        "
                                        color="black"
                                        menu-props="offsetY"
                                        item-color="secondary"
                                        open-on-clear
                                        hide-details="auto"
                                        class="pt-0"
                                        :loading="companyStoresLoading"
                                        validate-on-blur
                                        :search-input.sync="storesSearch.child"
                                    >
                                        <template v-slot:append-item>
                                            <div
                                                v-intersect="{
                                                    handler: (
                                                        entries,
                                                        observer
                                                    ) =>
                                                        endIntersect(
                                                            entries,
                                                            observer,
                                                            'child'
                                                        ),
                                                }"
                                            ></div>
                                        </template>
                                    </v-autocomplete>
                                </v-col> -->
                <v-col cols="12" sm="12" class="pt-0">
                  <v-autocomplete
                    :items="storesData.firstTransaction.stores"
                    item-text="app_name"
                    item-value="store_id"
                    v-model="filters.first_transaction_store_id"
                    :label="translations.first_transaction_store_id[lang]"
                    outlined
                    dense
                    clearable
                    :error-messages="error.first_transaction_store_id"
                    @change="
                      updateFilter('first_transaction_store_id', filters.first_transaction_store_id)
                    "
                    color="black"
                    menu-props="offsetY"
                    item-color="secondary"
                    open-on-clear
                    hide-details="auto"
                    class="pt-0"
                    :loading="companyStoresLoading"
                    validate-on-blur
                    :search-input.sync="storesSearch.firstTransaction"
                  >
                    <template v-slot:append-item>
                      <div
                        v-intersect="{
                          handler: (entries, observer) =>
                            endIntersect(entries, observer, 'firstTransaction'),
                        }"
                      ></div>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-autocomplete
                    :items="storesData.registration.stores"
                    item-text="app_name"
                    item-value="store_id"
                    v-model="filters.registration_store_id"
                    :label="translations.registration_store_id[lang]"
                    outlined
                    dense
                    clearable
                    :error-messages="error.registration_store_id"
                    @change="updateFilter('registration_store_id', filters.registration_store_id)"
                    color="black"
                    menu-props="offsetY"
                    item-color="secondary"
                    open-on-clear
                    hide-details="auto"
                    class="pt-0"
                    :loading="companyStoresLoading"
                    validate-on-blur
                    :search-input.sync="storesSearch.registration"
                  >
                    <template v-slot:append-item>
                      <div
                        v-intersect="{
                          handler: (entries, observer) =>
                            endIntersect(entries, observer, 'registration'),
                        }"
                      ></div>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" v-if="tiers && tiers.length">
                  <v-select
                    :items="tiers"
                    :label="translations.tiers[lang]"
                    item-value="store_point_title_id"
                    :item-text="(item) => (item.title && item.title[lang]) || item.name"
                    v-model="localTiers"
                    multiple
                    chips
                    outlined
                    dense
                    clearable
                    hide-details
                    @blur="onTiersBlur"
                    @click:clear="onTiersClear"
                  />
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" sm="" style="flex-grow: 3">
              <v-row>
                <v-col cols="12" md="12" class="pb-2">
                  <v-row>
                    <v-col cols="12" md="12" lg="6" xl="6" class="d-flex align-center">
                      <v-select
                        :items="countries"
                        item-text="name"
                        item-value="country_id"
                        v-model="filters.country_id"
                        :label="translations.country_id[lang]"
                        outlined
                        dense
                        clearable
                        hide-details
                        :error-messages="error.country_id"
                        @change="updateFilter('country_id', filters.country_id)"
                      >
                        <template v-slot:selection="{ item }">
                          <v-row no-gutters class="d-flex align-center">
                            <v-col class="mr-0">
                              <img
                                :src="item.flag"
                                width="25"
                                style="vertical-align: middle"
                                class="mr-0"
                              />
                            </v-col>

                            <v-col cols="auto">{{ item.name }}</v-col>
                          </v-row>
                        </template>
                        <template v-slot:item="{ item }">
                          <v-row no-gutters>
                            <v-col class="mr-3">
                              <img
                                :src="item.flag"
                                width="25"
                                style="vertical-align: middle"
                                class="mr-3"
                              />
                              {{ item.name }}
                            </v-col>
                          </v-row>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="12" lg="6" xl="6" class="d-flex align-center">
                      <v-select
                        :items="counties"
                        item-text="name"
                        item-value="county_id"
                        v-model="filters.county_id"
                        :label="translations.county_id[lang]"
                        outlined
                        :disabled="!filters.country_id"
                        dense
                        clearable
                        hide-details
                        :error-messages="error.county_id"
                        @change="updateFilter('county_id', filters.county_id)"
                      >
                        <template v-slot:selection="{ item }">
                          <v-row no-gutters class="d-flex align-center">
                            <v-col class="mr-0">
                              <img
                                :src="item.flag"
                                width="25"
                                style="vertical-align: middle"
                                class="mr-0"
                              />
                            </v-col>

                            <v-col cols="auto">{{ item.name }}</v-col>
                          </v-row>
                        </template>
                        <template v-slot:item="{ item }">
                          <v-row no-gutters>
                            <v-col class="mr-3">
                              <img
                                :src="item.flag"
                                width="25"
                                style="vertical-align: middle"
                                class="mr-3"
                              />
                              {{ item.name }}
                            </v-col>
                          </v-row>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" sm="4" class="pr-0">
                  <v-menu
                    ref="birthDateMenu"
                    v-model="birthDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filters.birth_date"
                        :label="translations.birth_date[lang]"
                        readonly
                        outlined
                        dense
                        clearable
                        v-bind="attrs"
                        v-on="on"
                        :error-messages="error.birth_date"
                        hide-details="auto"
                      />
                    </template>
                    <v-date-picker
                      v-model="filters.birth_date"
                      @input="birthDateMenu = false"
                      :max="new Date().toISOString().substr(0, 10)"
                      color="primary"
                      show-current
                      :locale="lang"
                      :first-day-of-week="1"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model.number="filters.minimum_age"
                    :label="translations.minimum_age[lang]"
                    type="number"
                    min="0"
                    max="120"
                    outlined
                    dense
                    clearable
                    :error-messages="error.minimum_age"
                    @change="updateFilter('minimum_age', filters.minimum_age)"
                    hide-details="auto"
                  />
                </v-col>

                <v-col cols="12" sm="4" class="pl-0">
                  <v-text-field
                    v-model.number="filters.maximum_age"
                    :label="translations.maximum_age[lang]"
                    type="number"
                    min="0"
                    max="120"
                    outlined
                    dense
                    clearable
                    :error-messages="error.maximum_age"
                    @change="updateFilter('maximum_age', filters.maximum_age)"
                    hide-details="auto"
                  />
                </v-col>
                <v-col cols="12" md="12" class="d-flex align-center pt-0 justify-center">
                  <div class="d-flex align-center mb-2 justify-center flex-column pt-0">
                    <v-checkbox
                      class="mr-0 pb-2"
                      v-model="genderActive"
                      :label="translations.gender[lang] + ':'"
                      @change="onGenderActiveChange"
                      dense
                      hide-details
                    />
                    <v-radio-group
                      v-model="filters.gender"
                      hide-details
                      :disabled="!genderActive"
                      @change="updateFilter('gender', filters.gender)"
                      row
                      class="ml-4 my-0"
                    >
                      <v-radio
                        v-for="option in genderOptions"
                        :key="option.value"
                        :label="`${translations[option.value][lang]}`"
                        :value="option.value"
                        hide-details
                      >
                        <template v-slot:label>
                          <v-icon
                            small
                            class="mr-1"
                            :color="option.value === filters.gender ? 'primary' : 'grey'"
                          >
                            {{ option.icon }}
                          </v-icon>
                          {{ translations[option.value][lang] }}
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="" style="flex-grow: 2">
              <div
                v-for="option in marketingOptions"
                :key="option.value"
                class="d-flex align-center mb-2"
              >
                <v-checkbox
                  :class="[option.value == 'marketing' ? 'is-marketing' : 'is-marketing-child']"
                  v-model="marketingActive[option.value]"
                  :label="translations[option.value][lang]"
                  :disabled="option.value !== 'marketing' && !filters['marketing']"
                  @change="onMarketingActiveChange(option.value)"
                  dense
                  hide-details
                />
                <v-radio-group
                  v-if="marketingActive[option.value]"
                  v-model="filters[option.value]"
                  row
                  hide-details
                  @change="updateFilter(option.value, filters[option.value])"
                  class="ml-4 my-0"
                >
                  <v-radio :label="translations.yes[lang]" :value="true" hide-details />
                  <v-radio :label="translations.no[lang]" :value="false" hide-details />
                </v-radio-group>
              </div>
            </v-col>
          </v-row>
          <v-col cols="12" sm="12" class="d-flex justify-end">
            <v-btn
              @click="advancedDialog = true"
              color="secondary"
              depressed
              class="text-capitalize"
            >
              {{ translations.moreFilters[lang] }}
            </v-btn>
          </v-col>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog v-model="advancedDialog" max-width="800px">
      <v-card>
        <v-card-title>
          {{ translations.advancedFilters[lang] }}
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <tbody>
              <tr>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>
                  {{ translations.total_transactions[lang] || 'Transactions' }}
                </td>
                <td>
                  <v-text-field
                    v-model.number="filters.minimum_total_transactions"
                    :label="translations.minimum_total_transactions[lang]"
                    type="number"
                    min="0"
                    outlined
                    dense
                    clearable
                    :error-messages="error.minimum_total_transactions"
                    @change="
                      updateFilter('minimum_total_transactions', filters.minimum_total_transactions)
                    "
                    hide-details="auto"
                  />
                </td>
                <td>
                  <v-text-field
                    v-model.number="filters.maximum_total_transactions"
                    :label="translations.maximum_total_transactions[lang]"
                    type="number"
                    min="0"
                    outlined
                    dense
                    clearable
                    :error-messages="error.maximum_total_transactions"
                    @change="
                      updateFilter('maximum_total_transactions', filters.maximum_total_transactions)
                    "
                    hide-details="auto"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  {{ translations.total_redemptions[lang] || 'Redemptions' }}
                </td>
                <td>
                  <v-text-field
                    v-model.number="filters.minimum_total_redemptions"
                    :label="translations.minimum_total_redemptions[lang]"
                    type="number"
                    min="0"
                    outlined
                    dense
                    clearable
                    :error-messages="error.minimum_total_redemptions"
                    @change="
                      updateFilter('minimum_total_redemptions', filters.minimum_total_redemptions)
                    "
                    hide-details="auto"
                  />
                </td>
                <td>
                  <v-text-field
                    v-model.number="filters.maximum_total_redemptions"
                    :label="translations.maximum_total_redemptions[lang]"
                    type="number"
                    min="0"
                    outlined
                    dense
                    clearable
                    :error-messages="error.maximum_total_redemptions"
                    @change="
                      updateFilter('maximum_total_redemptions', filters.maximum_total_redemptions)
                    "
                    hide-details="auto"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  {{ translations.total_amount[lang] || 'Amount' }}
                </td>
                <td>
                  <v-text-field
                    v-model.number="filters.minimum_total_amount"
                    :label="translations.minimum_total_amount[lang]"
                    type="number"
                    min="0"
                    outlined
                    dense
                    clearable
                    :error-messages="error.minimum_total_amount"
                    @change="updateFilter('minimum_total_amount', filters.minimum_total_amount)"
                    hide-details="auto"
                  />
                </td>
                <td>
                  <v-text-field
                    v-model.number="filters.maximum_total_amount"
                    :label="translations.maximum_total_amount[lang]"
                    type="number"
                    min="0"
                    outlined
                    dense
                    clearable
                    :error-messages="error.maximum_total_amount"
                    @change="updateFilter('maximum_total_amount', filters.maximum_total_amount)"
                    hide-details="auto"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  {{ translations[`current_balance_${storeMode}`][lang] || 'Balance' }}
                </td>
                <td>
                  <v-text-field
                    v-model.number="filters.minimum_current_balance"
                    :label="translations.minimum_current_balance[lang]"
                    type="number"
                    min="0"
                    outlined
                    dense
                    clearable
                    :error-messages="error.minimum_current_balance"
                    @change="
                      updateFilter('minimum_current_balance', filters.minimum_current_balance)
                    "
                    hide-details="auto"
                  />
                </td>
                <td>
                  <v-text-field
                    v-model.number="filters.maximum_current_balance"
                    :label="translations.maximum_current_balance[lang]"
                    type="number"
                    min="0"
                    outlined
                    dense
                    clearable
                    :error-messages="error.maximum_current_balance"
                    @change="
                      updateFilter('maximum_current_balance', filters.maximum_current_balance)
                    "
                    hide-details="auto"
                  />
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="advancedDialog = false"
            color="secondary"
            depressed
            class="text-capitalize"
          >
            {{ translations.close[lang] }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { mdiGenderMale, mdiGenderFemale, mdiGenderMaleFemale } from '@mdi/js';
import translations from '@/utils/translations/loyaltyPanel/customers';
import validators from '@/utils/validators/loyaltyPanel/customersFilters';
import { cloneDeep, debounce } from 'lodash';

export default {
  name: 'CustomerFilters',
  mixins: [validators, translations],
  data() {
    return {
      filtersPanel: [0],
      advancedDialog: false,
      birthDateMenu: false,
      genderActive: false,
      genderOptions: [
        {
          value: 'male',
          icon: mdiGenderMale,
        },
        {
          value: 'female',
          icon: mdiGenderFemale,
        },
        {
          value: 'other',
          icon: mdiGenderMaleFemale,
        },
      ],
      marketingOptions: [
        { value: 'marketing' },
        { value: 'sms' },
        { value: 'viber' },
        { value: 'push' },
        { value: 'mail' },
      ],
      marketingActive: {
        marketing: false,
        sms: false,
        viber: false,
        push: false,
        mail: false,
      },
      storesData: {
        child: {
          stores: [],
          pagination: { current_page: 1, previous_page: null },
        },
        firstTransaction: {
          stores: [],
          pagination: { current_page: 1, previous_page: null },
        },
        registration: {
          stores: [],
          pagination: { current_page: 1, previous_page: null },
        },
      },
      storesSearch: {
        child: '',
        firstTransaction: '',
        registration: '',
      },
      localTiers: [],
      debouncedSearchStores: () => {},
    };
  },
  computed: {
    ...mapState(['activeCountries']),
    ...mapState('loyaltyPanel', ['companyStores', 'companyStoresLoading']),
    ...mapState('loyaltyPanel/pointTitles', ['tiers', 'tiersLoading']),
    ...mapState('loyaltyPanel/customers', ['filtersData']),
    lang() {
      return this.$route.params.lang;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    filters: {
      get() {
        return this.filtersData;
      },
      set(val) {
        this.setFiltersData(val);
      },
    },
    countries: {
      get() {
        return this.activeCountries;
      },
      set(val) {
        this.setActiveCountries(val);
      },
    },
    counties() {
      return this.activeCountries.length && this.filters.country_id
        ? this.activeCountries.find((country) => country.country_id === this.filters.country_id)
            .counties
        : [];
    },
    activeFilters() {
      return Object.fromEntries(
        Object.entries(this.filters).filter(
          ([key, value]) =>
            value === false ||
            (Array.isArray(value)
              ? value.length > 0
              : typeof value === 'object' && value !== null
                ? Object.keys(value).length > 0
                : !!value)
        )
      );
    },
  },
  methods: {
    ...mapMutations(['setActiveCountries']),
    ...mapMutations('loyaltyPanel/customers', ['setFiltersData']),
    ...mapActions('loyaltyPanel', ['loadStores']),
    ...mapActions('loyaltyPanel/pointTitles', ['fetchPointTitles']),
    ...mapActions(['loadActiveCountries']),
    updateFilter(key, value) {
      const newFilters = { ...this.filters, [key]: value };
      this.setFiltersData(newFilters);
    },
    onTiersBlur() {
      if (this.localTiers && this.localTiers.length) {
        this.updateFilter('store_point_title_ids', this.localTiers);
      } else {
        this.updateFilter('store_point_title_ids', null);
      }
    },
    onTiersClear() {
      this.localTiers = [];
      this.updateFilter('store_point_title_ids', null);
    },
    onMarketingActiveChange(key) {
      if (this.marketingActive[key]) {
        this.updateFilter(key, true);
      } else {
        this.updateFilter(key, null);
        if (key === 'marketing') {
          this.marketingOptions.forEach((opt) => {
            if (opt.value !== 'marketing') {
              this.updateFilter(opt.value, null);
            }
          });
        }
      }
    },

    onGenderActiveChange() {
      if (this.genderActive) {
        this.updateFilter('gender', 'male');
      } else {
        this.updateFilter('gender', null);
      }
    },

    removeFilter(key) {
      const newFilters = { ...this.filters, [key]: null };
      this.setFiltersData(newFilters);
    },
    clearAllFilters() {
      const cleared = Object.fromEntries(Object.keys(this.filters).map((k) => [k, null]));
      this.setFiltersData(cleared);
      Object.keys(this.marketingActive).forEach((k) => {
        this.marketingActive[k] = false;
      });
    },

    async handleSearchStores(storeFilter) {
      this.storesData[storeFilter].pagination.current_page = 1;
      this.storesData[storeFilter].pagination.next_page = null;
      await this.getStores(storeFilter);
    },
    updateStoreData(storeFilter, data) {
      this.storesData[storeFilter].pagination = cloneDeep(data.pagination) || {};

      if (data.pagination?.current_page > 1) {
        this.storesData[storeFilter].stores = [
          ...this.storesData[storeFilter].stores,
          ...(data.stores || []),
        ];
      } else if (data.pagination?.current_page === 1) {
        this.storesData[storeFilter].stores = cloneDeep(data.stores) || [];
      }
    },

    endIntersect(entries, observer, storeFilter) {
      if (
        storeFilter &&
        this.storesData?.[storeFilter]?.stores?.length <
          this.storesData?.[storeFilter]?.pagination.total
      ) {
        this.loadMoreStores(storeFilter);
      }
    },

    getStoresQuery(data) {
      let q = `?page=${data.page}`;
      if (this.storesSearch[data.filter]) {
        q += `&q=${this.storesSearch[data.filter]}`;
      }
      return q;
    },
    async getStores(storeFilter) {
      let res = await this.loadStores({
        query: this.getStoresQuery({
          page: this.storesData[storeFilter].pagination.current_page,
          filter: storeFilter,
        }),
        page: this.storesData[storeFilter].pagination.current_page,
      });
      this.updateStoreData(storeFilter, res);
    },

    async loadMoreStores(storeFilter) {
      if (this.storesData[storeFilter].pagination?.next_page) {
        this.storesData[storeFilter].pagination.current_page =
          this.storesData[storeFilter].pagination.next_page;
        await this.getStores(storeFilter);
      }
    },
  },
  watch: {
    'filters.marketing': {
      handler(val) {
        if (!val) {
          this.marketingOptions.forEach((opt) => {
            if (opt.value != 'marketing') {
              this.updateFilter(opt.value, null);
              this.marketingActive[opt.value] = false;
            }
          });
        }
      },
      // deep: true,
      immediate: true,
    },
    'filters.country_id': {
      handler(val) {
        this.updateFilter('county_id', null);
      },
      immediate: false,
    },
    'filters.gender': {
      handler(val) {
        this.genderActive = val !== null;
      },
      immediate: true,
    },
    'storesSearch.child': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.debouncedSearchStores('child');
      }
    },
    'storesSearch.firstTransaction': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.debouncedSearchStores('firstTransaction');
      }
    },
    'storesSearch.registration': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.debouncedSearchStores('registration');
      }
    },
    'filters.store_point_title_ids': {
      handler(val) {
        this.localTiers = val || [];
      },
      immediate: true,
    },
  },
  async mounted() {
    if (!this.countries?.length) {
      this.loadActiveCountries();
    }
    if (!this.tiers?.length) {
      this.fetchPointTitles();
    }
    let res = await this.loadStores({
      page: 1,
      query: '',
    });
    this.updateStoreData('child', res);
    this.updateStoreData('firstTransaction', res);
    this.updateStoreData('registration', res);
    this.localTiers = this.filters.store_point_title_ids || [];
  },
  created() {
    this.debouncedSearchStores = debounce(this.handleSearchStores, 800);
  },
};
</script>
<style>
.red-x .v-icon.mdi-close-box {
  color: #f44336 !important;
}
.is-marketing .v-label {
  font-weight: bold;
}

.is-marketing-child.v-input {
  padding-left: 16px;
}
.no-flexing > * {
  flex: none !important;
}
</style>
